module.exports = __webpack_public_path__ + "static/design04-2317992e30c028fcc7ab59f20fb2763f.png";